// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=js"
// @generated from file sdk/events/v1/events.proto (package sdk.events.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PropertyValue } from "../../../common/v1/property_value_pb.js";
import { file_common_v1_property_value } from "../../../common/v1/property_value_pb.js";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sdk/events/v1/events.proto.
 */
export const file_sdk_events_v1_events: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_property_value, file_google_protobuf_timestamp]);

/**
 * @generated from message sdk.events.v1.BatchCreateRequest
 */
export type BatchCreateRequest = Message<"sdk.events.v1.BatchCreateRequest"> & {
  /**
   * @generated from field: repeated sdk.events.v1.Event events = 1;
   */
  events: Event[];
};

/**
 * Describes the message sdk.events.v1.BatchCreateRequest.
 * Use `create(BatchCreateRequestSchema)` to create a new message.
 */
export const BatchCreateRequestSchema: GenMessage<BatchCreateRequest> = /*@__PURE__*/
  messageDesc(file_sdk_events_v1_events, 0);

/**
 * @generated from message sdk.events.v1.BatchCreateResponse
 */
export type BatchCreateResponse = Message<"sdk.events.v1.BatchCreateResponse"> & {
  /**
   * @generated from field: uint32 accepted = 1;
   */
  accepted: number;

  /**
   * Events the server refused to ingest; accepted + dropped equals the number
   * sent. A drop is deliberately not an error: a batch may legitimately mix
   * cookieless and consented events, so failing the request would discard
   * healthy traffic to report a fault affecting only part of it. That makes
   * this field the only signal to the caller that anything was lost.
   *
   * @generated from field: uint32 dropped = 2;
   */
  dropped: number;

  /**
   * Per-reason breakdown of `dropped`, keyed by a stable reason token. This is
   * what makes a drop actionable rather than merely visible: `salt_unavailable`
   * is a server-side fault and the same payload may be retried, whereas
   * `day_out_of_range` is client clock skew that will drop again on every retry.
   *
   * @generated from field: map<string, uint32> dropped_by_reason = 3;
   */
  droppedByReason: { [key: string]: number };
};

/**
 * Describes the message sdk.events.v1.BatchCreateResponse.
 * Use `create(BatchCreateResponseSchema)` to create a new message.
 */
export const BatchCreateResponseSchema: GenMessage<BatchCreateResponse> = /*@__PURE__*/
  messageDesc(file_sdk_events_v1_events, 1);

/**
 * @generated from message sdk.events.v1.Event
 */
export type Event = Message<"sdk.events.v1.Event"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: map<string, common.v1.PropertyValue> auto_properties = 2;
   */
  autoProperties: { [key: string]: PropertyValue };

  /**
   * @generated from field: map<string, common.v1.PropertyValue> custom_properties = 3;
   */
  customProperties: { [key: string]: PropertyValue };

  /**
   * Empty only when cookieless (event.identity_required_unless_cookieless);
   * never client-settable to a 'cookieless-'-prefixed value
   * (batch.distinct_id_reserved_prefix).
   *
   * @generated from field: string distinct_id = 4;
   */
  distinctId: string;

  /**
   * Same character set as common.v1.EventFilter.kind (filters.proto); + requires non-empty at ingest.
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * @generated from field: google.protobuf.Timestamp occur_time = 6;
   */
  occurTime?: Timestamp | undefined;

  /**
   * A UUID whenever set; omit entirely in cookieless mode (an explicit "" is
   * also rejected — set fields must satisfy the uuid rule).
   *
   * @generated from field: string session_id = 7;
   */
  sessionId: string;

  /**
   * Cookieless (no-consent) mode: the client stores nothing on the device and
   * sends no identity; the ingest server derives an ephemeral daily-rotating
   * distinct_id and a stitched session_id. See docs/architecture/ingestion.md.
   *
   * @generated from field: bool cookieless = 8;
   */
  cookieless: boolean;
};

/**
 * Describes the message sdk.events.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_sdk_events_v1_events, 2);

/**
 * @generated from message sdk.events.v1.EventBatch
 */
export type EventBatch = Message<"sdk.events.v1.EventBatch"> & {
  /**
   * @generated from field: repeated sdk.events.v1.Event events = 1;
   */
  events: Event[];

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message sdk.events.v1.EventBatch.
 * Use `create(EventBatchSchema)` to create a new message.
 */
export const EventBatchSchema: GenMessage<EventBatch> = /*@__PURE__*/
  messageDesc(file_sdk_events_v1_events, 3);

/**
 * @generated from service sdk.events.v1.EventsService
 */
export const EventsService: GenService<{
  /**
   * @generated from rpc sdk.events.v1.EventsService.BatchCreate
   */
  batchCreate: {
    methodKind: "unary";
    input: typeof BatchCreateRequestSchema;
    output: typeof BatchCreateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sdk_events_v1_events, 0);

